class CartItems extends HTMLElement{
    constructor(){
        super();
        this.removeBtns = this.querySelectorAll('.remove-btn');
        this.plusQtyBtns = this.querySelectorAll('.ajaxcart__qty--plus');
        this.minusQtyBtns = this.querySelectorAll('.ajaxcart__qty--minus');
        this.inputQty = this.querySelectorAll('.ajaxcart__qty-num');
    }
    connectedCallback(){
        var self = this;
        this.removeBtns.forEach((btn) =>{
            btn.addEventListener('click', this.removeItem.bind(this))
        })
        this.plusQtyBtns.forEach((btn) =>{
            btn.addEventListener('click',() => {
                let parent = btn.parentNode
                let input = parent.querySelector('input');
                let oldValue = parseInt(input.value)
                input.value = oldValue + 1;
                input.dispatchEvent(new Event('change'))
            })
        })
        this.minusQtyBtns.forEach((btn) =>{
            btn.addEventListener('click',() => {
                let parent = btn.parentNode
                let input = parent.querySelector('input');
                let oldValue = parseInt(input.value)
                if(oldValue > 1){
                    input.value = oldValue - 1;
                    input.dispatchEvent(new Event('change'))
                }
            })
        })
        this.inputQty.forEach(input => {
            input.addEventListener('change', this.debounce((event) => {
                this.updateQuantity(event.target.dataset.key,event.target.value)
            }, 1000));
        })
        document.addEventListener('update:cart',this.updateQuantity.bind(this))
    }
    debounce(callback, delay) {
        let timeout;
        return (...args) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
            callback(...args);
        }, delay);
        };
    }
    removeItem(e){
        var key = e.currentTarget.dataset.key;
        this.updateQuantity(key,0)
    }
    updateQuantity(key,qty){
        console.log(key,qty)
        var updates = {};
        updates[key] = qty;
        fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({updates})
        })
        .then(response => {
            return response.json();
        })
        .then(response => {
            this.renderCart()
        })
        .catch((error) => {
            console.error('Error:', error);
        });
    }
    renderCart(){
        fetch(window.Shopify.routes.root + '?section_id=header-new')
        .then(res => res.text())
        .then(responseText => {
            const html = new DOMParser().parseFromString(responseText, "text/html");
            document.getElementById('CartPopup').innerHTML = html.querySelector('#CartPopup').innerHTML
        })
    }
}
customElements.define("cart-items", CartItems);
class CartTable extends HTMLElement{
  constructor(){
    super();
  }
  connectedCallback(){
    var times = 0;
    var myInterval = setInterval(() => {
        if(typeof Spurit != "undefined" || times >=50){
            clearInterval(myInterval);
            this.querySelectorAll('.cart__row').forEach(row => {
              var productId = row.dataset.product;
              if(Spurit?.Preorder2?.settings?.products[productId]?.config?.buttonMessage){
                row.querySelector('.viewreorder-extrainfo').innerText = Spurit?.Preorder2?.settings?.products[productId]?.config?.buttonMessage || 'Orders will ship immediately upon stock availability.'
              }
            })
        }
    },200)
  }
}
customElements.define("cart-table", CartTable);